import { Card, Container, Row, Col, ProgressBar } from "react-bootstrap";
import FixStar from "./FixStar";

interface Summary {
    avgRating: number,
    total: number,
    resultArr: number[]
}

export default function ResultSummary({ avgRating, total, resultArr }: Summary): JSX.Element {

    let star5 = parseFloat((resultArr[5] * 100 / total).toFixed(2));
    let star4 = parseFloat((resultArr[4] * 100 / total).toFixed(2));
    let star3 = parseFloat((resultArr[3] * 100 / total).toFixed(2));
    let star2 = parseFloat((resultArr[2] * 100 / total).toFixed(2));
    let star1 = parseFloat((resultArr[1] * 100 / total).toFixed(2));
    let star0 = parseFloat((resultArr[0] * 100 / total).toFixed(2));

    return (
        <Container className='summary-div'>
            <Row>
                <Col lg={6}>
                    <Card className='summary-card'>
                        <h4>Summary</h4>
                        <Card.Body className='summary-card-body'>
                            <Row>
                                <Col lg={4}>
                                    <FixStar stars={5} fixStar={Math.floor(avgRating)} />
                                </Col>
                                <Col>
                                    {`${avgRating.toFixed(1)} out of 5`}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {`${total} customer ratings`}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    5 Star
                                </Col>
                                <Col lg={6} className='result-progress-bar'>
                                    <ProgressBar now={star5} />
                                </Col>
                                <Col>
                                    {`${star5}%`}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    4 Star
                                </Col>
                                <Col lg={6} className='result-progress-bar'>
                                    <ProgressBar now={star4} />
                                </Col>
                                <Col>
                                    {`${star4}%`}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    3 Star
                                </Col>
                                <Col lg={6} className='result-progress-bar'>
                                    <ProgressBar now={star3} />
                                </Col>
                                <Col>
                                    {`${star3}%`}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    2 Star
                                </Col>
                                <Col lg={6} className='result-progress-bar'>
                                    <ProgressBar now={star2} />
                                </Col>
                                <Col>
                                    {`${star2}%`}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    1 Star
                                </Col>
                                <Col lg={6} className='result-progress-bar'>
                                    <ProgressBar now={star1} />
                                </Col>
                                <Col>
                                    {`${star1}%`}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={2}>
                                    0 Star
                                </Col>
                                <Col lg={6} className='result-progress-bar'>
                                    <ProgressBar now={star0} />
                                </Col>
                                <Col>
                                    {`${star0}%`}
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}